export enum __ViewErrorCode {
    invalid = 'invalid',
    noPublish = 'no_publish',
    disableForm = 'disable_form',
    sourceUnique = 'source_unique',
    brokenPublish = 'broken_publish',
    invalidSource = 'invalid_source',
    parameterUnique = 'parameter_unique',
    invalidParameter = 'invalid_parameter',
    parameterDatalistUnidque = 'parameter_datalist_unique',
}

export enum __AnswerErrorCode {
    invalidPassword = 'invalid_password',
    passwordRequired = 'password_required',
}

export interface __AnswerApiErrType {
    non_field_errors: { code: __AnswerErrorCode }[];
}

export interface __ViewApiErrType {
    non_field_errors: { code: __ViewErrorCode }[];
}
